import { useState, useEffect } from "react";
import CreamProductCard from "@/components/CreamProductCard";
import { productsByCategory } from "@/data/products";
import { goToShopifyCollection } from "@/lib/shopify";

/**
 * T-Shirts Section — cream gallery grid.
 */
export const TShirtsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const tees = productsByCategory("tshirts");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setIsVisible(true)),
      { threshold: 0.1 }
    );
    const el = document.getElementById("tshirts-section");
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="tshirts-section"
      data-testid="tshirts-section"
      className="section-padding bg-[#F4EFE6] relative"
    >
      <div className="container-luxury">
        <div
          className={`text-center mb-16 md:mb-24 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-[11px] tracking-[0.4em] uppercase text-stone-500 mb-5">
            UNIXORN — Tees
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-stone-900">
            T-SHIRTS
          </h2>
          <p className="text-base md:text-lg text-stone-600 tracking-wide max-w-2xl mx-auto">
            Four sigils. One language. Each tee a quiet relic.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
          {tees.map((p, idx) => (
            <div
              key={p.id}
              className={`transition-all duration-1000 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <CreamProductCard product={p} />
            </div>
          ))}
        </div>

        <div className="text-center mt-20">
          <button
            onClick={() => goToShopifyCollection("tshirts")}
            className="text-stone-600 hover:text-stone-900 transition-colors text-xs tracking-[0.4em] uppercase"
            data-testid="tshirts-see-all"
          >
            View All T-Shirts →
          </button>
        </div>
      </div>
    </section>
  );
};

export default TShirtsSection;
